import { useIsTeamsApp, useShowNavigation } from "@hooks";
import { Navigation } from "../../Navigation";
import { cn } from "@utils";

export const Footer = () => {
  const showNavigation = useShowNavigation();
  const isTeamsApp = useIsTeamsApp();

  if (!showNavigation) {
    return <></>;
  }

  return (
    <div
      className={cn("flex overflow-hidden sm:hidden items-center justify-center sticky px-4 z-10 bg-white", {
        "top-0 border-b": isTeamsApp,
        "bottom-0 border-t": !isTeamsApp,
      })}
      style={{ gridArea: "footer / fullbleed" }}>
      {showNavigation && <Navigation footer />}
    </div>
  );
};
